import React from 'react';

import Col from 'react-bootstrap/Col';
import CurrencyInput from '../shared/inputs/CurrencyInput';
import CustomTd from '../shared/table/CustomTd';
import DeleteButton from '../shared/buttons/DeleteButton';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import SelectList from '../shared/inputs/SelectList';

const AreaEditor = ({
    deleteItem,
    disabled,
    formChange,
    item
}) => {
    const restrictDelete = item.newItem || disabled;

    return (
        <tr>
            <CustomTd className="border-0">
                <Form.Row>
                    <Col sm={6} className="mb-2 mb-sm-0">
                        <SelectList
                            lookupType="AreaType"
                            name="areaTypeId"
                            onChange={formChange}
                            placeholder="Area Type"
                            required={!item.newItem}
                            validationError={item.areaTypeId_error}
                            value={item.areaTypeId}
                            disabled={disabled}
                        />
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            defaultValue={item.description}
                            name="description"
                            onChange={formChange}
                            placeholder="Description"
                            required={!item.newItem}
                            validationError={item.description_error}
                            disabled={disabled}
                        />
                    </Col>
                </Form.Row>
            </CustomTd>
            <CustomTd width="110px" className="border-0">
                <CurrencyInput
                    name="amount"
                    onChange={formChange}
                    placeholder="Amount"
                    required={!item.newItem}
                    validationError={item.amount_error}
                    value={item.amount}
                    disabled={disabled}
                />
            </CustomTd>
            <CustomTd width="45px" className="button-cell border-0">
                <div className="button-wrapper d-inline-block">
                    <DeleteButton
                        confirmDelete={false}
                        onClick={deleteItem}
                        showText={false}
                        disabled={restrictDelete}
                    />
                </div>
            </CustomTd>
        </tr>
    );
}

export default AreaEditor;